/**
 * This token will be overwritten at run-time by each client.
 */
export let getToken = () => undefined;
export let getRefreshToken = () => undefined;
export let setToken = () => undefined;
export let onLogout = () => undefined;
export let platform = 'web';
export function initializeAuthCallbacks(cbs) {
    // This function is overwritten by each client.
    if (cbs.getToken)
        getToken = cbs.getToken;
    if (cbs.getRefreshToken)
        getRefreshToken = cbs.getRefreshToken;
    if (cbs.setToken)
        setToken = cbs.setToken;
    if (cbs.onLogout)
        onLogout = cbs.onLogout;
    platform = cbs.platform;
}
//# sourceMappingURL=auth.js.map